export enum InventoryActivityTypes {
  Waste = 1,
  Discrepancy = 2,
  Other = 3,
  AuditDiscrepancy = 20,
  TransferDiscrepancy = 21,
  DispenseDiagnosisCode = 30,
  DispenseLabelNotes = 31,
  DispenseRequiredNotes = 32,
  DispenseScanBypass = 33,
}
